/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Footer_Etbis_Logo_AltInputs */

const tr_legal_footer_etbis_logo_alt = /** @type {(inputs: Legal_Footer_Etbis_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ETBİS Kayıtlı - shoppanel.emonse.com`)
};

const en_legal_footer_etbis_logo_alt = /** @type {(inputs: Legal_Footer_Etbis_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registered with ETBİS: shoppanel.emonse.com`)
};

const de_legal_footer_etbis_logo_alt = /** @type {(inputs: Legal_Footer_Etbis_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei ETBİS registriert: shoppanel.emonse.com`)
};

const ru_legal_footer_etbis_logo_alt = /** @type {(inputs: Legal_Footer_Etbis_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зарегистрировано в ETBİS: shoppanel.emonse.com`)
};

/**
* | output |
* | --- |
* | "Registered with ETBİS: shoppanel.emonse.com" |
*
* @param {Legal_Footer_Etbis_Logo_AltInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const legal_footer_etbis_logo_alt = /** @type {((inputs?: Legal_Footer_Etbis_Logo_AltInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Footer_Etbis_Logo_AltInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_footer_etbis_logo_alt(inputs)
	if (locale === "de") return de_legal_footer_etbis_logo_alt(inputs)
	if (locale === "ru") return ru_legal_footer_etbis_logo_alt(inputs)
	return tr_legal_footer_etbis_logo_alt(inputs)
});